import { FieldType } from '@/catalog/constants/fieldTypes';
import { returnFieldValue } from '@/catalog/helpers/returnFieldValue';
import { Field } from '@/catalog/types/field';
import { ALL_CONTEXTS } from '@/common/constants/context';
import ProductLink from '@/product/components/ProductLink/ProductLink';

export const FIELD_SKU: Field = {
  label: 'SKU',
  fullLabel: 'Product SKU',
  key: 'sku',
  type: FieldType.Scalar,
  getValue(p) {
    return p.b2bSid || null;
  },
  getText: returnFieldValue,
  render(p, { useLink = true } = {}) {
    if (!p.b2bSid) {
      return null;
    }

    return useLink ? <ProductLink product={p} text={p.b2bSid} /> : p.b2bSid;
  },
  contexts: ALL_CONTEXTS,
};
